/* RESPONSIBLE TEAM: team-ai-agent */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { DRAWER_EDITOR_QUERY_PARAMS } from 'embercom/services/knowledge-hub-drawer-editor-service';
import type { EditorMode } from 'embercom/components/knowledge-hub/content-editor/drawer-editor';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import { registerDestructor } from '@ember/destroyable';

export default class AskController extends Controller {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;

  queryParams = [...DRAWER_EDITOR_QUERY_PARAMS];

  // Knowledge hub drawer editor query params
  @tracked activeContentId?: number;
  @tracked activeContentType?: string;
  @tracked editorMode?: EditorMode;
  @tracked collectionId?: string;
  @tracked contentLocale?: string;
  @tracked folderId?: string;

  // Proposal state (managed internally, not via URL - React manages chatId in URL)
  @tracked proposalChatId: string | null = null;
  @tracked proposalUuid: string | null = null;

  constructor(properties?: object) {
    super(properties);

    // Subscribe to view-proposal events from React
    let unsubscribe = this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
      'internal-agent:view-proposal',
      (data: Record<string, unknown>) => {
        this.proposalChatId = data.chatId as string;
        this.proposalUuid = data.proposalUuid as string;
      },
    );
    registerDestructor(this, unsubscribe);
  }

  get isProposalPanelOpen(): boolean {
    return this.proposalChatId !== null && this.proposalUuid !== null;
  }

  @action
  closeProposalPanel(): void {
    // Notify React to close the main content area
    this.reactTeammateAppIsland.dispatchBridgeEvent('teammate-app:event', {
      identifier: 'internal-agent:main-content-closed',
      data: {},
    });

    this.proposalChatId = null;
    this.proposalUuid = null;
  }
}
